import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import { useNavigate } from 'react-router';

import WithError from '../../../../components/with-error/WithError';
import PasswordInput from '../../../../components/common-inputs/PasswordInput';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import CommonTip from '../../../../components/common-tip/CommonTip';
import CommonButtonLink from '../../../../components/common-button-link/CommonButtonLink';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';

import scss from './ConfirmAdImagesForm.module.scss';

function ConfirmAdImagesForm({ onSubmit }) {
  const { t } = useTranslation('demoAdImages');
  const { submitting: isLoading } = useFormState();
  const navigate = useNavigate();

  const handleOpenDemoRequestForm = () => {
    navigate('/ad/images/demo/request');
  };

  return (
    <form className={scss.form} onSubmit={onSubmit}>
      <h1 className={scss.title}>{t('reCreateImagesDemo')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>
          {t('enterPasswordToGetAccessToAdImages')}
          <CommonTip tip={t('passwordSendingToYourEmail')} />
        </h4>

        <Field name='password'>
          {({ input, meta }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <PasswordInput
                formProps={input}
                autoComplete='password'
                placeholder={t('password')}
                disabled={isLoading}
                isError={meta.touched && meta.error}
                LeftIcon={<Icon icon={ICONS.Lock} />}
              />
            </WithError>
          )}
        </Field>
      </div>

      <div className={scss.buttons}>
        <TooltipButton styleColor='primary' type='submit' maxWidth={190} isLoading={isLoading}>
          {t('submit')}
        </TooltipButton>

        <CommonButtonLink styleColor={BUTTON_STYLES.SECONDARY} onClick={handleOpenDemoRequestForm} type='button'>
          {t('doNotHaveDemoAccess')}
        </CommonButtonLink>
      </div>
    </form>
  );
}

export default ConfirmAdImagesForm;
